import { Auth, getAuth, connectAuthEmulator } from 'firebase/auth';
import { app } from './startFirestore';
import { environmentType, deploymentEnvironment, emulatorPorts } from '../config';

/**
 * Connect Auth emulator on development environment and local deployment
 * @param auth Auth instance
 */
export const connectAuthEmulatorOnDev = async (auth: Auth) => {
  if (environmentType === 'development' && deploymentEnvironment === 'local') {
    try {
      connectAuthEmulator(auth, `http://localhost:${emulatorPorts.auth}`, { disableWarnings: true });
      console.log('Connected to Firebase Auth emulator');
    } catch (error: any) {
      // Ignore "already initialized" errors
      if (!error.message?.includes('already been called')) {
        console.error('Error connecting to auth emulator', error);
      }
    }
  }
};

/**
 * Initialize Auth instance
 */
export const auth: Auth = getAuth(app);

// Connect to Auth emulator if in development
connectAuthEmulatorOnDev(auth); 